<template>
    <div class="container-fluid head">
        <div class="container">
            <div class="header row">
                <div class="col-sm text-center text-md-left logo-container" >
                    <img src="../assets/SVG/PayGate-Plus.svg" alt="PayGate Plus" class="pg-logo img-responsive">
                </div>
                <div class="col generic-spacer d-block d-xs-block d-lg-none"></div>
                <div class="col-sm text-center text-md-right" >
                    <a class="btn btn-primary dpo-sa-btn" href="https://www.paygate.co.za/?utm_source=web&utm_medium=link&utm_campaign=Solidarity&utm_content=top" target="_blank">VISIT DPO SA</a>
                </div>
            </div>
        </div>
        <div class="logo-main row">
            <div class="container arms text-center">
                <img src="../assets/SVG/Solidarity-Fund.svg" alt="Solidarity Fund" class="solidarity-logo">
                <h2 class="thats-solidarity d-none d-sm-block d-md-block d-lg-block d-xl-block">#ThatsSolidarity</h2>
                <h2 class="thats-solidarity-mobile d-block d-sm-none d-md-none d-lg-none d-xl-none">#ThatsSolidarity</h2>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Header'
  }
</script>

